module.exports = __webpack_public_path__ + "static/media/plus_sign.311313cd.svg";